import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const StepIndicator = ({ steps, activeStep }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 4,
        gap: 0,
      }}
    >
      {steps.map((step, index) => {
        const isActive = index === activeStep;
        const isCompleted = index < activeStep;

        return (
          <React.Fragment key={step.id}>
            {/* Step circle + label — in one row */}
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: 13,
                  flexShrink: 0,
                  border: isActive || isCompleted
                    ? 'none'
                    : `2px solid ${theme.palette.divider}`,
                  bgcolor: isActive || isCompleted
                    ? theme.palette.primary.main
                    : 'background.paper',
                  color: isActive || isCompleted ? '#fff' : 'text.disabled',
                  transition: 'all 0.3s ease',
                  boxShadow: isActive ? `0 4px 16px ${theme.palette.primary.main}44` : 'none',
                }}
              >
                {index + 1}
              </Box>
              <Typography
                variant="caption"
                fontWeight={isActive ? 700 : 400}
                color={isActive ? 'primary' : 'text.disabled'}
                sx={{
                  fontSize: 11,
                  letterSpacing: 0.5,
                  textTransform: 'uppercase',
                  whiteSpace: 'nowrap',
                  transition: 'color 0.3s',
                }}
              >
                {step.label}
              </Typography>
            </Box>

            {/* Connector line */}
            {index < steps.length - 1 && (
              <Box
                sx={{
                  height: 2,
                  flex: 1,
                  mx: 1,
                  bgcolor: index < activeStep ? theme.palette.primary.main : theme.palette.divider,
                  transition: 'background-color 0.3s ease',
                  minWidth: 60,
                  maxWidth: 120,
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default StepIndicator;